import { Grid, InfoIcon, SxProps, Tooltip, Typography, TypographyProps } from '@methanesat/ui-components';
import { DataRowsModalBodyLabel } from './DataRowsModalBodyLabel';
import { DataRow } from '../../../../types';
import { isSlug } from 'validator';
import { slugify } from '../../../../utils';
isSlug;
/** Todo: DP-1001 Enforce label and value key lengths by validating user input */
export const DataRowsModalBody = ({
    dataRows,
    TypographyProps
}: {
    dataRows: DataRow[];
    sx?: SxProps;
    TypographyProps?: Partial<TypographyProps>;
}) => {
    return (
        <>
            {dataRows
                .filter(({ label, value }) => label && value)
                .map(({ label, value, toolTip, mobileLabel, icon, href }, idx) => (
                    <Grid container justifyContent="space-between" alignItems="top" key={label} paddingBottom={1}>
                        <Grid size="auto" sx={(theme) => ({ paddingRight: theme.spacing(4) })}>
                            <DataRowsModalBodyLabel
                                data-testid={label ? slugify(label) : `data-row-label-${idx}`}
                                label={label}
                                href={href}
                                mobileLabel={mobileLabel}
                                icon={icon}
                                {...TypographyProps}
                            />
                        </Grid>
                        <Grid size="grow" display="flex" justifyContent="flex-end" alignItems="center">
                            <Typography
                                variant="body2"
                                align="right"
                                sx={{ wordBreak: 'break-word' }}
                                component="div"
                                {...TypographyProps}
                            >
                                {value}
                            </Typography>
                            {toolTip && (
                                <Tooltip title={toolTip} sx={{ marginLeft: 1, fontSize: 18 }}>
                                    <InfoIcon />
                                </Tooltip>
                            )}
                        </Grid>
                    </Grid>
                ))}
        </>
    );
};
